import React from 'react'
function EmandateRegistered() {
  return (
    <div className="payment-error-eman-box">
      <p>
       Your e-mandate registration is successful. Please pay your first installment.
      </p>
  </div>
  )
}
export default EmandateRegistered
